import { useQuery } from '@tanstack/react-query';
import { admin } from '@repletoryreach/sdk-api';

/**
 * Every user on the platform, newest first. The response carries a window
 * (`meta.total`, `meta.returned`, `meta.capped`), so a caller can tell a
 * complete list from the newest slice rather than guessing from the row count.
 */
export function useUsers(scope?: 'tenant' | 'platform') {
  return useQuery({
    queryKey: ['admin', 'users', scope ?? 'all'],
    queryFn: () => admin.listUsers(scope ? { scope } : undefined)
  });
}
